import i18next from 'i18next';

import { deleteDatasheet } from 'common/api/datasheets';
import alerts from 'common/modules/alerts';
import showToast from 'common/utils/showToast';

import {
    DELETE_DATASHEET,
    DELETE_DATASHEET_FAILURE,
    DELETE_DATASHEET_SUCCESS,
} from '../actionTypes';
import { productDatasheetsActions } from '../reducer';

import fetchProductDatasheet from './fetchProductDatasheet';

export default (productId) => (dispatch) => {
    dispatch(productDatasheetsActions[DELETE_DATASHEET]());

    deleteDatasheet(productId)
        .then(() => {
            dispatch(productDatasheetsActions[DELETE_DATASHEET_SUCCESS]({}));
            dispatch(alerts.actions.close());
            dispatch(fetchProductDatasheet(productId));
            showToast({
                body: i18next.t('It was successfully removed'),
            });
        })
        .catch((error) => {
            dispatch(
                productDatasheetsActions[DELETE_DATASHEET_FAILURE](
                    error.response.data.errors,
                ),
            );
            dispatch(alerts.actions.close());

            const dataAlert = {
                confirmText: i18next.t('Close'),
                messages: [
                    `${i18next.t('Whoops, something went wrong')}:`,
                    ...error.response.data.errors,
                ],
                title: i18next.t('Error'),
                type: alerts.ALERT_TYPE_ALERT,
                variant: 'error',
            };

            dispatch(alerts.actions.show(dataAlert));
        });
};
